import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ShieldCheck } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setError(""); setLoading(true);
    try { await login(email, password); nav("/"); }
    catch (e) { setError(formatApiErrorDetail(e.response?.data?.detail) || e.message); }
    finally { setLoading(false); }
  }

  const demo = [
    ["Administrator", "tigaputrabiotechsejahtera@gmail.com", "admin123"],
    ["Petugas Gudang", "gudang@tigaputra.com", "gudang123"],
    ["Petugas QC", "qc@tigaputra.com", "qc123"],
    ["Manajer", "manajer@tigaputra.com", "manajer123"],
  ];

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex flex-col justify-between p-12 bg-primary text-primary-foreground relative overflow-hidden">
        <div className="relative z-10">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-xl bg-white/15 grid place-items-center font-heading font-extrabold">TP</div>
            <div>
              <div className="font-heading font-bold text-lg">PT TIGA PUTRA BIOTECH SEJAHTERA</div>
              <div className="text-sm opacity-80">UD TIGA PUTRA</div>
            </div>
          </div>
        </div>
        <div className="relative z-10">
          <h1 className="font-heading text-4xl font-extrabold leading-tight">Sistem Penerimaan &amp; Traceability Bahan Baku</h1>
          <p className="mt-4 opacity-80 max-w-md">Pencatatan penerimaan, pemeriksaan mutu MJ-FORM-01, label batch, FIFO, dan penelusuran bahan sampai produk jadi.</p>
        </div>
        <div className="relative z-10 text-xs opacity-70">FORMULIR MJ-FORM-01 • Terbitan 0 • Efektif 2026</div>
        <div className="absolute -right-20 -bottom-20 w-96 h-96 rounded-full bg-white/5" />
        <div className="absolute right-10 top-10 w-40 h-40 rounded-full bg-white/5" />
      </div>
      <div className="flex items-center justify-center p-6">
        <div className="w-full max-w-sm">
          <div className="flex items-center gap-2 mb-6 text-primary"><ShieldCheck /><span className="font-heading font-bold">Masuk ke Sistem</span></div>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1" />
            </div>
            <div>
              <Label htmlFor="password">Kata Sandi</Label>
              <Input id="password" data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1" />
            </div>
            {error && <div data-testid="login-error" className="text-sm text-red-600">{error}</div>}
            <Button data-testid="login-submit" type="submit" disabled={loading} className="w-full">{loading ? "Memproses..." : "Masuk"}</Button>
          </form>
          <div className="mt-6 border-t pt-4">
            <div className="text-xs font-semibold text-muted-foreground mb-2">Akun demo (klik untuk isi):</div>
            <div className="space-y-1">
              {demo.map(([r, em, pw]) => (
                <button key={em} data-testid={`demo-${em}`} onClick={() => { setEmail(em); setPassword(pw); }}
                  className="w-full text-left text-xs px-3 py-1.5 rounded border border-slate-200 hover:bg-accent flex justify-between">
                  <span className="font-medium">{r}</span><span className="text-muted-foreground">{em}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
